import { defineStore } from 'pinia';
import { ref } from 'vue';

import type { ErrorState } from './types';

/**
 * Centralised error state.
 *
 * The store holds data only — no copy defaults, no Apollo knowledge. Use the
 * `useError` composable for the Russian defaults and the Apollo handlers.
 */
export const useErrorStore = defineStore('error', () => {
  const error = ref<ErrorState | null>(null);

  /**
   * Set the error state directly.
   * For the default copy per status code use `useError().showError()`.
   */
  const setError = (errorState: ErrorState) => {
    error.value = errorState;
  };

  const clearError = () => {
    error.value = null;
  };

  /** Alias for `clearError`, for the Pinia convention. */
  const $reset = () => {
    error.value = null;
  };

  return {
    error,
    setError,
    clearError,
    $reset,
  };
});
